import { useSelector } from "react-redux";
import { State } from "@App/state";
import { selectNetworkId } from "@App/state/selectors/orders";
import { useQuery } from "@apollo/client";
import {
  GET_ORGANIZATION_PREMIUM_SERVICES,
  OrganizationPremiumServicesQuery,
} from "@App/graphql/queries/getOrganizationPremiumServices";
import { useNetwork } from "./useNetwork";

export const useOrganizationPremiumServices = () => {
  const organization = useSelector((state: State) => state.orders.organization);
  const service = useSelector((state: State) => state.orders.service);
  const driverID = useSelector((state: State) => state.auth?.driverData?.uuid);
  const networkId = useSelector(selectNetworkId);
  const presetFilters = useSelector((state: State) => state.filters.presetFilters);

  const { loading: networkLoading } = useNetwork();

  const { loading, data, error } = useQuery<OrganizationPremiumServicesQuery>(
    GET_ORGANIZATION_PREMIUM_SERVICES,
    {
      variables: {
        organization: organization.id,
        services: [service.id],
        driver: driverID ?? null,
        network: networkId ?? null,
        ...(presetFilters &&
          presetFilters.length > 0 && {
            presetFilters: presetFilters,
          }),
      },
      skip: networkLoading,
    },
  );

  return {
    loading: loading || networkLoading,
    error: error,
    data: data,
  };
};
